/* globals $, $H, Class, jui, lp, rxSwitchboard */
var jQuery = require('jquery');
var _ = require('lodash');

var Animate = require('ub/ui/animate');

var rxUi = window.rxUi;
var ubBanzai = window.ubBanzai;

var LP_PAGE_ELEMENT_TREE_SUBS = [];

var animator = new Animate();

lp.editor.PageElementTree = Class.create( jui.Component, {
  options: function($super,options){
    // for now the editor is a jui.Component that grabs the 'content' div as it's element
    return $super($H({attributes:{className:'page-element-tree editor-content-tree'}}).merge(options));
  },

  initialize: function($super,editor,options) {
    this.editor = editor;
    editor.addListener('elementMouseover', this);
    editor.addListener('elementMouseout', this);
    editor.addListener('elementActivated', this);
    editor.addListener('elementDeactivated', this);

    var updateFunction = this.updateTree.bind(this);
    editor.addListener('elementInserted', updateFunction);
    editor.addListener('elementRemoved', updateFunction);
    editor.addListener('elementOrderChanged', updateFunction);
    editor.addListener('elementShown', updateFunction);
    editor.addListener('elementHidden', updateFunction);
    editor.addListener('elementDuplicated', updateFunction);
    editor.addListener('elementPasted', updateFunction);
    editor.addListener('elementContainerChanged', updateFunction);
    editor.addListener('elementZIndexChanged', updateFunction);

    this.modelListener = this.modelChanged.bind(this);
    this.ignoreNameEditBlur = false;

    // we need to clean up the subscriptions when in test mode as the subs would accumulate
    LP_PAGE_ELEMENT_TREE_SUBS.forEach(function (sub) {
      sub.dispose();
    });
    LP_PAGE_ELEMENT_TREE_SUBS = [];
    editor.addListener('pageLoaded', function() {
      var sub = rxSwitchboard.subjects.jui_events
        .filter(function(ev) {
          return ev.type === 'pageUpdatedAndRefreshed';
        })
        .subscribe(function() {
          //TODO-TR: this should never happen but leave it in until we
          //have a standard exception reporting rx .subscribe wrapper fn
          try {
            updateFunction();
          } catch (e) {
            console.trace(e);
          }
        });
      LP_PAGE_ELEMENT_TREE_SUBS.push(sub);
    });

    _.bindAll(this);
    $super(options);
  },

  _createAndGetNameEditField: function(elm) {
    if(this.nameEditField){this.nameEditField.remove();}

    this.nameEditField = new jui.Component({
      elementType:'input',
      attributes:{type:'text', className:'name-edit'}
    });

    var self = this;
    this.nameEditField.e.observe('blur', function(){
      var elId = jQuery(self.nameEditField.e).attr('data-element');
      if(elId) {
        var newName = _.escape(jQuery.trim(self.nameEditField.e.value));
        if(newName.length > 0) {
          self._uiBinding.onNext({
            type: 'renameElement',
            elementId: elId,
            newName: newName
          });
        }
      }
    });

    var $e = jQuery('#menu-item-' + elm.id);

    if (!elm.is('renamable')) {return;}

    var scrollTop = jQuery('.page-element-tree.editor-content-tree').scrollTop();
    var $node  = $e.find('a');
    var offset = $node.position();

    offset.top = offset.top - scrollTop;

    offset.left += parseInt($node.find('.content-tree-node-title').css('padding-left'), 10) + 59;
    offset.top += parseInt(this.e.scrollTop, 10) + 8;

    this.nameEditField.setOffset(offset);
    this.nameEditField.setWidth(this.getWidth() - offset.left - 20);

    this.nameEditField.e.setValue(elm.model.get('name'));

    jQuery(this.nameEditField.e).attr('data-element', elm.id);

    this.insert(this.nameEditField);
    this.nameEditField.e.select();

    return this.nameEditField;
  },

  installUI: function($super){
    $super();
    this._uiBinding = new rxUi.Binding('PageElementTree');
    this._uiBinding.subscribe(this._intrepretDomainEvent);
  },

  _intrepretDomainEvent: function(ev) {
    if(ev.type) {
      var func = this['_' + ev.type];
      if(typeof func === 'function') {
        return func(ev);
      }
    }

    //We should not be here.  Not a valid type;
    throw new TypeError('invalid event type: ' + ev.type);
  },

  _getElement: function(ev) {
    if(!ev.elementId){throw new TypeError('Missing element id');}

    return window.editor.page.getElementById(ev.elementId);
  },

  _selectElement: function(ev) {
    this.fireEvent('elementSelected', this._getElement(ev));
  },

  _toggleVisibility: function(ev) {
    this._handleVisibility(this._getElement(ev).model);
  },

  _toggleSubtree: function(ev) {
    var $e = jQuery('#menu-item-' + this._getElement(ev).id);
    $e.toggleClass('closed');
    if (this.nameEditField) {
      this.nameEditField.remove();
    }
  },

  _beginEditElementName: function(ev) {
    var elm = this._getElement(ev);
    this.nameEditField = this._createAndGetNameEditField(elm);

    this.editor.keyController.requestFocus(this, true);
  },

  _renameElement: function(ev) {
    if (this.ignoreNameEditBlur) {return;}
    this._getElement(ev).setName(ev.newName);
    this.nameEditField.hide();
  },

  _handleVisibility: function(elModel) {
    rxSwitchboard.fireUIEvent({
      elementId: elModel.element.id,
      type: 'toggleVisibility',
      domTarget: 'contents-panel'
    });
  },

  _isCurrentModelFormButton: function(elModel) {
    return elModel.element.getType() === 'lp-pom-button' &&
      elModel.element.isFormButton();
  },

  onkeydown: function(e) {
    switch (e.keyCode){
      case Event.KEY_RETURN:
        this.nameEditField.e.blur();
        e.stop();
        break;
    }
  },

  blur: function() {
    this.nameEditField.hide();
  },

  elementMouseover: function(e) {
    var elm = e.data.source;
    var li = this.getListItem(elm);
    if (li) {
      li.addClassName('over');
    }
  },

  elementMouseout: function(e) {
    var elm = e.data.source;
    var li = this.getListItem(elm);
    if (li) {
      li.removeClassName('over');
    }
  },

  elementActivated: function(e) {
    var elm = e.data;
    var li = this.getListItem(elm);
    if (li) {
      li.addClassName('active');
      li.querySelector('.content-tree-node-title').classList.add('selected-element-highlight');
      if (this.hasVisiblityToggle()) {
        li.querySelector('.content-tree-node-visibility-state').classList.add('selected-element-highlight');
      }

      if (ubBanzai.features.isScrollContentTreeEnabled()) {
        animator.scrollElementIntoContainerView(li, this.e);
      }
    }
  },

  elementDeactivated: function(e) {
    var elm = e.data;
    var li = this.getListItem(elm);
    if (li) {
      li.removeClassName('active');
      li.querySelector('.content-tree-node-title').classList.remove('selected-element-highlight');
      if (this.hasVisiblityToggle()){
        li.querySelector('.content-tree-node-visibility-state').classList.remove('selected-element-highlight');
      }
    }
  },

  getListItem: function(elm) {
    if (this.e && elm) {
      // this.e is null sometimes, possibly due to a timing issue
      // https://unbounce.hipchat.com/search?q=TypeError%3A+Cannot+read+property+%27down%27+of+null&t=rid-13895&a=Search#05:59:35
      return this.e.down('li[id="menu-item-'+elm.id+'"]');
    } else {
      return null;
    }
  },

  _shouldUpdateTree: function(e) {
    // For now we don't update the tree if its panel isn't currently open and visible to
    // the user. It will be updated when the panel is opened. When this module is
    // converted to use virtual-dom we may be able to remove this hack. Also, some events
    // or the elements they contain are flagged to not require a content tree update.
    return this.editor.activeRoot &&
           this.editor.treeToggler.isOpen() &&
           ! (e && e.data && e.data.updateElementTreeOnInsert === false) &&
           ! (e && e.data && e.data.data && e.data.data.updateElementTree === false);
  },

  updateTree: function(e) {
    if (this._shouldUpdateTree(e)) {
      this.setRoot(this.editor.activeRoot);
    }
  },

  modelChanged: function(e) {
    var accessor = e.data.accessor;
    if (accessor === 'name' || accessor === 'geometry.visible') {
      var menuItem = $('menu-item-'+e.source.element.id);
      if(menuItem) {
        menuItem.down('a').update(this.createElementNodeContent(e.source.element));
      } else if(ubBanzai.features.isDebugModeEnabled()) {
        console.trace('MenuItem down not defined');
      }
    } else if (accessor === 'action.type') {
        this.updateTreeIcon(e.source.element);
    }
  },

  updateTreeIcon: function(elm, a) {
    var action = elm.model.safeGet('action.type');
    var $menuItemLink = a ? jQuery(a) : jQuery('#menu-item-' + elm.id + ' a');

    if (elm.type === 'lp-pom-button' &&
      (action === 'externalLightbox' || action === 'internalLightbox') ) {
        $menuItemLink.attr('class', 'lp-pom-lightbox-button content-tree-node-wrapper');
    } else {
        $menuItemLink.attr('class', elm.type + ' content-tree-node-wrapper');
    }
  },

  createElementNodeContent: function(elm) {
    return this.getNameNodeContent(elm) + (this.hasVisiblityToggle() ? this.getVisibilityIconNodeString(elm.model) : '');
  },

  _shorten: function(name) {
    var maxLength = 14;

    if(name.length > maxLength) {
      return name.substr(0, maxLength - 3) + '...';
    }

    return name;
  },

  getNameNodeContent: function(elm) {

    var svgIcons = {
      'lp-pom-block':'svg-ico-page-section',
      'lp-pom-box':'svg-ico-box',
      'lp-pom-text':'svg-ico-text',
      'lp-pom-image':'svg-ico-image',
      'lp-pom-button':'svg-ico-button',
      'lp-pom-lightbox':'svg-ico-lightbox',
      'lp-pom-lightbox-button':'svg-ico-lightbox',
      'lp-pom-form':'svg-ico-form',
      'lp-pom-video':'svg-ico-video',
      'lp-pom-code':'svg-ico-html',
      'lp-code':'svg-ico-html',
      'lp-pom-social-widget':'svg-ico-social'
    };

    var name = elm.model.get('name');
    return [
    '<span class="content-tree-node-title ctt ', svgIcons[elm.type], '" title="', name, '">',
      this.hasVisiblityToggle() ? '<span class="content-tree-visibility-toggle"></span>' : '',
      '<span class="content-tree-node-title-text">',
      name,
      '</span>',
    '</span>'].join(' ');
  },

  getVisibilityIconNodeString: function(elModel) {
    var visible       = elModel.isVisible() ? 'visible' : 'lp-hidden';
    return ['<span class="content-tree-node-visibility-state visibility-state svg-ico-eye-opened ', visible, '"></span>'].join(' ');
  },

  setPage: function(p) {
    this.setRoot(p.getRootElement());
  },

  getElementTypeAsClass: function(el) {
    if(this._isCurrentModelFormButton(el.model)) {
      return el.type + ' lp-pom-button-form';
    }

    return el.type;
  },

  listClosedItems: function() {
    return _.map(jQuery('li.arr.closed'), function(item) {
      return jQuery(item).attr('id');
    });
  },

  handleClosedListItems: function(closedItems, listItemID, li) {
    if(_.contains(closedItems, listItemID)) {
      jQuery(li).addClass('closed');
    }
  },

  hasVisiblityToggle: function() {
    return window.editor.page.getConfigValue('allowVisibilityToggle');
  },

  setRoot: function(root){
    this.ignoreNameEditBlur = true;
    var closedItems = this.listClosedItems();

    this.clear();
    this.ignoreNameEditBlur = false;

    var tree = this.insert(new Element('ul', {'class':'editor-content-tree-list'}))
      , self = this
      , activeElement = window.editor.activeElement;

    var makeElementListItem = function(elm){
      var fireEvent = function(eventType)  {
        self._uiBinding.onNext({
          type: eventType,
          elementId: elm.id
        });
      };

      var a = new Element('a',{'href':'#'})
      .update(self.createElementNodeContent(elm))
      .observe('click', function(e){
        if(jQuery(e.target).hasClass('visibility-state')) {
          fireEvent('toggleVisibility');
        } else {
          fireEvent('selectElement');
        }

        if(self.nameEditField) {
          self.nameEditField.hide();
        }
      })
      .observe('dblclick', function(){fireEvent('beginEditElementName');});

      var div = new Element('div', {className:'menu-item content-tree-node'})
        , listItemID = 'menu-item-' + elm.id;

      var li = new Element('li',{
        'class':self.getElementTypeAsClass(elm) + ' editor-content-tree-group-list-item',
        id: listItemID
      }).insert(div.insert(a));

      self.handleClosedListItems(closedItems, listItemID, li);

      div.observe('click', function(e){
        e.stop();
        if(jQuery(e.target).hasClass('menu-item') || jQuery(e.target).hasClass('content-tree-visibility-toggle')) {
          fireEvent('toggleSubtree');
        }
      });

      li.observe('mouseover', function(e) {
        e.stop();
        var $target = jQuery(e.target);
        var $li = $target.is('li') || $target.is('ul') ? $target : $target.closest('ul, li');
        $li.addClass('content-tree-item-hover');
      });

      li.observe('mouseout', function(e) {
        e.stop();
        var $target = jQuery(e.target);
        var $li = $target.is('li') || $target.is('ul') ? $target : $target.closest('ul, li');
        $li.removeClass('content-tree-item-hover');
      });

      self.updateTreeIcon(elm, a);
      elm.model.addListener('attributeChanged', self.modelListener);

      var ul = new Element('ul', {'class': 'editor-content-tree-group-list ctn'});
      elm.childElements.sortBy(function(e){
          return -e.model.getZIndex();
        }).each(function(c){
            if (c.is('displayable')) {
                ul.insert(makeElementListItem(c));
            }
        });

      if (elm.childElements.length > 0) {
        li.addClassName('arr editor-content-tree-group');
        li.insert(ul);
      }
      if(!elm.model.isVisible()) {
        li.addClassName('lp-hidden');
      }
      if (elm === activeElement) {
        li.addClassName('active');
        li.querySelector('.content-tree-node-title').classList.add('selected-element-highlight');
        if (self.hasVisiblityToggle()) {
          li.querySelector('.content-tree-node-visibility-state').classList.add('selected-element-highlight');
        }
      }
      return li;
    };

    if (root.childElements.length > 0) {
      this.removeClassName('empty-tree');
      root.childElements.each(function(c){
        if (c.is('displayable')) {
            tree.insert(makeElementListItem(c));
        }
      }, this);
    } else {
      this.addClassName('empty-tree');
      this.insert(new Element('p', {'class':'missing-content-message'}).update('Drag a Page Section onto the page to start adding content to this page'));
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/page_element_tree.js
// module id = 1011
// module chunks = 0